<div class="row" [@show]="isImpersonating">
    <p>Estas viendo el dashboard de {{impersonatedUserDisplayName}}<a class="backLink" (click)="clearImpersonation($event)">Volver a mi dashboard</a></p>
</div>